import TransactionEditContext from "context/TransactionEditContext";
import { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { getCompany } from "state/slices/company";
import Appointment from "./Appointment";
import Cessation from "./Cessation";
import ChangeOfParticulars from "./ChangeOfParticulars";
import SelectChangeForm from "./ChangeSelection";

const OfficialsShareholdersAuthorisedPersons = (props) => {
  const { changeType, trxRef } = props;
  const { companyId } = useParams();
  const dispatch = useDispatch();
  const [selectedChange, setselectedChange] = useState("");
  const [whichFormToBeRendered, setWhichFormToBeRendered] = useState("");
  const [similarTransactionIsUnderway, setSimilarTransactionIsUnderway] =
    useState(false);

  const [showProceedButton, setShowProceedButton] = useState(true);
  const [showCompanyOfficialsForm, setShowCompanyOfficialsForm] =
    useState(true);
  const [formStepErrors, setFormStepErrors] = useState({
    selectedOfficial: "",
    typeOfChange: "",
  });
  const [formFieldsToRender, setFormFieldsToRender] = useState({
    recentTableToBeRender: "",
    message: "",
  });
  const [formData, setFormData] = useState({
    designation: props.official?.designation ? props.official?.designation : "",
    idType: props.official?.idType ? props.official?.idType : "",
    idTypeOptions: [],
    selectedDesignation: props.official?.designation
      ? props.official?.designation
      : "",
  });

  const handleSubmit = async (event) => {
    event.preventDefault();
    const errors = { ...formStepErrors };
    if (formData.selectedDesignation === "") {
      errors.selectedOfficial = "Official type is required!";
    } else {
      errors.selectedOfficial = "";
    }

    if (formData.idType === "") {
      errors.typeOfChange = "ID type is required!";
    } else {
      errors.typeOfChange = "";
    }
    setFormStepErrors(errors);

    const { idType, selectedDesignation } = formData;
    setFormFieldsToRender({
      officialMethod: selectedDesignation,
      idTypeSelection: idType,
      moduleType: "Manage Module",
    });
    setWhichFormToBeRendered(idType);
  };

  useEffect(() => {
    dispatch(getCompany({ id: companyId }));
  }, []);

  const { isInTransactionEditContext } = useContext(TransactionEditContext);
  useEffect(() => {
    if (isInTransactionEditContext) {
      if (changeType === "APPOINTMENT") {
        setFormData((prevState) => ({
          ...prevState,
          idType: "Appointment",
        }));
        setWhichFormToBeRendered("Appointment");
      } else if (changeType === "CESSATION") {
        setFormData((prevState) => ({
          ...prevState,
          idType: "Cessation",
        }));
        setWhichFormToBeRendered("Cessation");
      } else if (changeType === "CHANGE-OF-PARTICULARS") {
        setFormData((prevState) => ({
          ...prevState,
          idType: "Change of Particulars",
        }));
        setWhichFormToBeRendered("Change of Particulars");
      }
    }
  }, [isInTransactionEditContext, changeType]);
  return (
    <div>
      <div>
        <SelectChangeForm
          formData={formData}
          setFormData={setFormData}
          handleSubmit={handleSubmit}
          setWhichFormToBeRendered={setWhichFormToBeRendered}
          formStepErrors={formStepErrors}
          setFormStepErrors={setFormStepErrors}
          setSimilarTransactionIsUnderway={setSimilarTransactionIsUnderway}
          showProceedButton={showProceedButton}
          setShowProceedButton={setShowProceedButton}
          setShowCompanyOfficialsForm={setShowCompanyOfficialsForm}
        />
        {/* {similarTransactionIsUnderway ? (
          <div className="mt-4 py-2">
            <h2>Similar transaction is underway</h2>
          </div>
        ) : ( */}
        <div className="mt-4 py-2">
          {whichFormToBeRendered === "Appointment" && (
            <Appointment
              companyId={companyId}
              addOfficialProcessType={formFieldsToRender}
              setWhichFormToBeRendered={setWhichFormToBeRendered}
              selectedDesignation={formData.selectedDesignation}
              changeType={formData.idType}
              official={props.official}
              trxRef={trxRef}
              setShowProceedButton={setShowProceedButton}
              showCompanyOfficialsForm={showCompanyOfficialsForm}
              setShowCompanyOfficialsForm={setShowCompanyOfficialsForm}
            />
          )}
          {whichFormToBeRendered === "Change of Particulars" && (
            <ChangeOfParticulars
              companyId={companyId}
              formFields={formFieldsToRender}
            />
          )}
          {whichFormToBeRendered === "Cessation" && (
            <Cessation companyId={companyId} formFields={formFieldsToRender} />
          )}
        </div>
        {/* )} */}
      </div>
    </div>
  );
};

export default OfficialsShareholdersAuthorisedPersons;
